import { useLanguage } from "../context/LanguageContext";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { usePageContent } from "../hooks/usePageContent";
import { SEO } from "../components/SEO";

export default function ReturnsPage() {
  const { t } = useLanguage();
  const { data, loading } = usePageContent("returns");

  if (loading) return <div className="px-6 md:px-12 lg:px-24 py-20"><p className="text-sm text-[#9CA3AF]">{t("common.loading")}</p></div>;

  const sections = data?.sections || [];

  return (
    <div className="px-6 md:px-12 lg:px-24 py-12 md:py-20 max-w-3xl" data-testid="returns-page">
      <SEO title="Returns & Refunds" description="Mona Luxe 14-day return policy. Easy returns on all pre-owned designer handbags. Full refund on unused items." path="/returns" />
      <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#9CA3AF] hover:text-[#1A1A1A] transition-colors mb-10">
        <ArrowLeft size={14} strokeWidth={1.5} /> {t("common.back")}
      </Link>
      <h1 className="text-3xl md:text-4xl mb-12" style={{ fontFamily: "'Playfair Display', serif" }} data-testid="returns-title">
        {data?.title || t("footer.returns_policy")}
      </h1>
      <div className="space-y-12 text-sm leading-relaxed tracking-wide text-[#1A1A1A]/80">
        {sections.map((s, i) => (
          <section key={i}>
            <h2 className="text-base font-normal mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>{s.title}</h2>
            {s.content.split("\n").map((line, j) => (
              <p key={j} className={j > 0 ? "mt-2" : ""}>{line}</p>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
